import React from 'react';
import renderHTML from 'react-render-html';
import { ToggleButton } from 'telstra-ui/components/toggle/ToggleButton';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import { preparePerformanceOptionsArry } from '../../ngm-homepage.actions';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import './customer_question.css';

const CustomerQuestion = (props) => {
  const {
    customerQuestionData: {
      heading,
      description,
      performanceHeading,
      perfomanceExplanation,
      appsDescription,
      performanceQuestions,
      questions,
    },
    handleOnClickQuestion,
    handleOnselectPrfm,
    performanceSelectedOptions,
  } = props;

  const getHtmlTextWithoutPipeSign = htmlText => htmlText.replace('|', '');

  const displayQuestionsCheckbox = () => {
    const question = questions.map((questionItem, index) => {
      const optionsCheckBox = questionItem.options.map((option, subIndex) => (
        <div key={`question-checkbox-${subIndex + 1}`} className="customer-question-options col-12 pl-sm-0">
          <Checkbox
            key={`${option.key}-${index + 1}`}
            onChange={handleOnClickQuestion}
            label={renderHTML(getHtmlTextWithoutPipeSign(option.value))}
            id={`${option.key}-${index}`}
            value={`${option.key}-${index}`}
            className="question-checkbox"
            name={`${index + 1}`}
          />
        </div>
      ));
      return (
        <div className="customer-question" key={`Q${index + 1}`}>
          <SummaryDetails
            summaryTitle={questionItem.questionText}
            customHeadingClass="heading20"
          />
          <div className="row">
            {optionsCheckBox}
          </div>
        </div>
      );
    });

    return question;
  };

  const displayperformanceQuestions = () => {
    const question = performanceQuestions.map((questionItem, index) => (
      <div className="performance-question" key={`Q${index + 1}`}>
        <SummaryDetails
          summaryTitle={questionItem.questionText}
          customHeadingClass="heading16"
        />
        <div className="row pl-sm-0">
          <ToggleButton
            className="performance-selection-box"
            size="large"
            name={`Q${index + 1}`}
            id={`Q${index + 1}`}
            options={preparePerformanceOptionsArry(questionItem.options, index)}
            value={performanceSelectedOptions[index]}
            selectionMode="single"
            onChange={handleOnselectPrfm}
          />
        </div>
      </div>
    ));
    return question;
  };

  return (
    <div className="customer-question-section padding-top-bottom-24">
      <SummaryDetails
        summaryTitle={heading}
        summaryText={description}
        customHeadingClass="heading34"
      />
      <div className="performance-question-section padding-top-bottom-24">
        <SummaryDetails
          summaryTitle={performanceHeading}
          summaryText={perfomanceExplanation}
          customHeadingClass="heading20 performance-heading"
        />
        <div className="performance-question-list">
          {displayperformanceQuestions()}
        </div>
      </div>
      <div className="app-description-section row">
        <div className="col-12 pl-sm-0 pr-sm-0">
          {renderHTML(stripStartingAndEndingPTags(appsDescription))}
        </div>
      </div>
      <div className="customer-question-list padding-top-bottom-24 pb-0">
        {displayQuestionsCheckbox()}
      </div>
    </div>
  );
};

export default CustomerQuestion;
